import { useMemo, useCallback, ChangeEvent } from 'react';
import { useField } from 'formik';
import { Input } from '@app/form';
import { vatPlaceholders } from './vatPlaceholders';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  label?: string;
  noMargin?: boolean;
  requiredStar?: boolean;
  onChange?: (val?: string | null) => any;
  currentCountry?: string;
}

export const VatNumberField = ({
  onChange: _onChange,
  name: nameProp,
  label,
  requiredStar,
  currentCountry,
  noMargin,
}: Props) => {
  const { t } = useTranslation();
  const [{ name }, { value: vatNumber, error, touched }, { setValue }] =
    useField({
      name: nameProp,
    });

  const vatNumberError =
    touched && typeof error === 'string' ? t(error) : undefined;
  const onChange = useCallback(
    (val?: string | null) => {
      setValue(val);
      if (_onChange) {
        _onChange(val);
      }
    },
    [_onChange, setValue],
  );

  const placeholder = useMemo(() => {
    return (
      vatPlaceholders.find(({ countryKey }) => countryKey === currentCountry)
        ?.placeholder || ''
    );
  }, [currentCountry]);

  const onValueChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.currentTarget.value || null);
    },
    [onChange],
  );

  return (
    <Input
      label={label}
      noMargin={noMargin}
      requiredStar={requiredStar}
      placeholder={placeholder}
      onChange={onValueChange}
      value={vatNumber || ''}
      name={name}
      error={vatNumberError}
    />
  );
};
